import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Table, Button, Col, Modal, Row, Container, Dropdown, Alert, Form } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';
import ModalList from '../../components/Modals/ModalList';
import ModalEntityViewer from '../../components/Modals/ModalEntityViewer';
import ModalListPicker from '../../components/Modals/ModalListPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import moment from 'moment';
import { WriteXml } from 'fattura-elettronica';
import { settings } from '../settings';
import { Editor } from '@tinymce/tinymce-react';
import FieldPreview from '../../components/Entity/FieldPreview';
import DGLTH_customer_order from '../components/DGLTH_customer_order';
import DGLTH_supplier_order from '../components/DGLTH_supplier_order';



export default function DataGridLastTdHook({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()


    //customer
    const [customerHistoryEntity, setCustomerHistoryEntity] = useState(null)
    const [customerHistorySearchObj, setCustomerHistorySearchObj] = useState(null)
    const [statusCustomerModal, setStatusCustomerModal] = useState(false)
    const [statusPaymentModal, setStatusPaymentModal] = useState(false)
    const [paymentEntity, setPaymentyEntity] = useState(null)
    const [paymentSearchObj, setPaymentSearchObj] = useState(null)
    const userInfo = LoginManager.getUserInfo();
    function showCustomerOffer(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setCustomerHistorySearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setCustomerHistoryEntity('customer_offer')
        setStatusCustomerModal(true)
    }
    function showCustomerOrder(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setCustomerHistorySearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setCustomerHistoryEntity('customer_order')
        setStatusCustomerModal(true)
    }
    function closeCustomerModal() {
        setCustomerHistoryEntity(null)
        setStatusCustomerModal(false)
    }



    function showModalPayment(item) {
        let query = ''
        let fields = []
        let constraints = [{ "fieldName": "idCustomer", type: "value", value: item.id }]

        setPaymentSearchObj({
            query: query,
            fields: fields,
            constraints: constraints
        })

        setPaymentyEntity('customer_order_payment')
        setStatusPaymentModal(true)
    }
    function closeModalPayment() {
        setPaymentyEntity(null)
        setStatusPaymentModal(false)
    }

    function newCustomerOffer(item) {
        navigate('/entity/customer_offer/add', {
            state: {
                body: {
                    idCustomer: item
                }
            }
        })
    }
    function newCustomerOrder(item) {
        navigate('/entity/customer_order/add', {
            state: {
                body: {
                    idCustomer: item
                }
            }
        })
    }




    //customer offer
    function previewCustomerOffer(item) {
        navigate('/page/CustomerOfferPreview?id=' + item.id)
    }
    const [statusModalEntityViewerCustomerOffer, setStatusModalEntityViewerCustomerOffer] = useState(false)
    function closeModalEntityViewerCustomerOffer() {
        setStatusModalEntityViewerCustomerOffer(false)
    }
    function openModalEntityViewerCustomerOffer() {
        setStatusModalEntityViewerCustomerOffer(true)
    }

    function ddtCustomerOrder(item) {
        navigate('/page/CustomerDdtPreview?id=' + item.id)
    }

    async function customerOfferConvertInOrder() {
        var userInfo = LoginManager.getUserInfo();
        console.warn('item', item)
        const id = toast.loading("Conversione preventivo...")

        if (item.status && item.status.value === "10_CONFIRMED") {
            toast.update(id, { render: "Questo preventivo è già stato convertito in ordine.", type: "error", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
        }
        else {
            var body = {
                status: { value: '10_CONFIRMED' }
            }
            var response = await DataManager.updateItem('customer_offer', body, item.id)
            console.warn(response)
            if (response.success === 1) {
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraints = [{ "fieldName": "levelUser", type: "value", value: 1 }]
                var resNotifiche = await DataManager.searchItems('gyv_notification', 1, 50, sorting, '', [], constraints);
                console.log(resNotifiche);
                if (resNotifiche.success === 1 && resNotifiche.body.length > 0) {
                    for (let i = 0; i < resNotifiche.body.length; i++) {
                        if (resNotifiche.body[i].notificationAll === 1 && resNotifiche.body[i].notificationOffer === 1) {
                            var bodyEmail = {
                                emailTo: resNotifiche.body[i].emailUser,
                                riferimento: item.internalCode,
                                idOrder: item.id,
                                entity: 'offer',
                                stato: 'CONVERTITO IN ORDINE'
                            }
                            var responseEmail = await ApiManager.sendAuthenticatedRequest('/custom/send_mail_change_status', bodyEmail);
                            console.warn(responseEmail);
                        }
                    }
                }

                var sortingOffer = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraintsOffer = [{ "fieldName": "id", type: "value", value: item.id }]
                var resultOffer = await DataManager.searchItems('customer_offer', 1, 50, sortingOffer, '', [], constraintsOffer);
                if (resultOffer.success === 1) {

                    console.log(resultOffer);
                    toast.update(id, { render: "Preventivo confermato. Compila l'ordine con i campi mancanti. RICORDATI DI SALVARE L'ORDINE.", type: "success", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
                    navigate('/entity/customer_order/add', {
                        state: {
                            body: {
                                idCustomerOffer: { id: item.id },
                                idCustomer: resultOffer.body[0].idCustomer,
                                idSalesAgent: resultOffer.body[0].idSalesAgent,
                                discount: resultOffer.body[0].discount,
                                notes: resultOffer.body[0].notes,
                                rows: resultOffer.body[0].rows,
                                files: resultOffer.body[0].files,
                                riferimento: resultOffer.body[0].riferimento,
                                status: { value: '0_PENDING' },
                                vat: resultOffer.body[0].vat,
                                idPaymentCondition: resultOffer.body[0].idPaymentCondition ? { id: resultOffer.body[0].idPaymentCondition.id, name: resultOffer.body[0].idPaymentCondition.name } : null,
                                parking: resultOffer.body[0].parking,
                                parquet: resultOffer.body[0].parquet,
                                pedestrian_zone: resultOffer.body[0].pedestrian_zone,
                                hoist_elevator: resultOffer.body[0].hoist_elevator,
                                floor: resultOffer.body[0].floor,
                                no_traffic_zone: resultOffer.body[0].no_traffic_zone,
                                building: resultOffer.body[0].building,
                                zone: resultOffer.body[0].zone,
                                ladder_truck: resultOffer.body[0].ladder_truck,
                                elevator: resultOffer.body[0].elevator,
                                increase: resultOffer.body[0].increase,
                                discount: resultOffer.body[0].discount,
                                transportCost: resultOffer.body[0].transportCost,
                                deliveryDate: resultOffer.body[0].deliveryDate,
                                deliveryAddress: resultOffer.body[0].deliveryAddress,
                                locality: resultOffer.body[0].locality,
                            }
                        }
                    })

                }


                console.log(body);
            }
            else {
                if (response.message && response.message != '') {
                    toast.update(id, { render: response.message, type: "error", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
                }
                else {
                    toast.update(id, { render: "Non è stato possibile convertire questo preventivo.", type: "error", isLoading: false, autoClose: 3000, closeOnClick: true, theme: "colored" });
                }
            }
        }
    }


    async function revert() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [{ "fieldName": "idCustomerOffer", type: "value", value: item.id }]
        var result = await DataManager.searchItems('customer_order', 1, 50, sorting, '', [], constraints);
        if (result.success === 1) {
            if (result.body.length > 0) {
                toast.error('Impossibile fare il revert in quanto è già presente un ordine creato da questo preventivo', { theme: 'colored', position: 'bottom-center' })
            } else {
                var data = {
                    status: { value: '0_PENDING' }
                }
                var update = await DataManager.updateItem('customer_offer', data, item.id);
                if (update.success === 1) {
                    toast.success('Revert eseguito con successo!', { theme: 'colored', position: 'bottom-center' })
                    refreshData()
                }
            }
        }

    }

    async function declined() {
        var update = await DataManager.updateItem('customer_offer', { status: { value: "20_DECLINED" } }, item.id)
        if (update.success === 1) {
            toast.success("Preventivo rifiutato con successo!", { theme: 'colored', position: 'bottom-center' })
            closeModalDelete()
            refreshData()
        } else {
            toast.error(update.message, { theme: 'colored', position: 'bottom-center' });
            closeModalDelete()
        }
    }

    function downloadXml() {
        const xmlString = item.xml;

        const blob = new Blob([xmlString], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'file.xml';

        document.body.appendChild(a);
        a.click();

        a.remove();
    }

    async function generateXml(item) {
        console.log(item)
        if (item.progressivo !== null) {
            var res = await DataManager.getItem('customer_order', item.idCustomerOrder.id);
            if (res.success === 1) {
                var r = res.body[0];
                var temp = [];
                for (let i = 0; i < r.rows.length; i++) {
                    temp.push({
                        NumeroLinea: i + 1,
                        Descrizione: r.rows[i].description,
                        Quantita: r.rows[i].quantity + '.0000',
                        UnitaMisura: 'PZ',
                        PrezzoUnitario: parseFloat(r.rows[i].listPrice).toFixed(2),
                        PrezzoTotale: parseFloat(r.rows[i].price).toFixed(2),
                        AliquotaIVA: r.vat + '.00'
                    })
                }

                console.log(res)


                var dateNow = moment().format('YYYY-MM-DD');

                const fattura = {
                    FatturaElettronicaHeader: {
                        DatiTrasmissione: {
                            IdTrasmittente: {
                                IdPaese: settings.dati_fattura.statoPIVA,
                                IdCodice: settings.dati_fattura.PIVA,
                            },
                            ProgressivoInvio: item.progressivo,
                            FormatoTrasmissione: settings.dati_fattura.formatoTrasmissione,
                            CodiceDestinatario: settings.dati_fattura.codiceDestinatario,
                        },
                        CedentePrestatore: {
                            DatiAnagrafici: {
                                IdFiscaleIVA: {
                                    IdPaese: settings.dati_fattura.statoPIVA,
                                    IdCodice: settings.dati_fattura.PIVA,
                                },
                                CodiceFiscale: settings.dati_fattura.PIVAcompleta,
                                Anagrafica: {
                                    Denominazione: settings.dati_fattura.denominazione,
                                },
                                RegimeFiscale: settings.dati_fattura.regimeFiscale,
                            },
                            Sede: {
                                Indirizzo: settings.dati_fattura.indirizzo,
                                CAP: settings.dati_fattura.cap,
                                Comune: settings.dati_fattura.comune,
                                Provincia: settings.dati_fattura.provincia,
                                Nazione: settings.dati_fattura.nazione
                            },
                            IscrizioneREA: {
                                Ufficio: settings.dati_fattura.ufficio,
                                NumeroREA: settings.dati_fattura.numeroREA,
                                SocioUnico: settings.dati_fattura.socioUnico,
                                StatoLiquidazione: settings.dati_fattura.statoLiquidazione
                            },
                        },
                        CessionarioCommittente: {
                            DatiAnagrafici: {
                                IdFiscaleIVA: {
                                    IdPaese: 'IT',
                                    IdCodice: r.idCustomer.vatNumber
                                },
                                CodiceFiscale: r.idCustomer.vatNumber,
                                Anagrafica: {
                                    Denominazione: r.idCustomer.name,
                                },
                            },
                            Sede: {
                                Indirizzo: r.idCustomer.route + ', ' + r.idCustomer.streetNumber,
                                CAP: r.idCustomer.postalCode,
                                Comune: r.idCustomer.locality,
                                Provincia: r.idCustomer.province,
                                Nazione: r.idCustomer.country
                            },
                        },
                    },
                    FatturaElettronicaBody: [
                        {
                            DatiGenerali: {
                                DatiGeneraliDocumento: {
                                    TipoDocumento: 'TD01',
                                    Divisa: 'EUR',
                                    Data: dateNow,
                                    Numero: r.internalCode,
                                    ImportoTotaleDocumento: parseFloat(r.totalPrice).toFixed(2),
                                    /* Arrotondamento: '', */
                                    Causale: ''
                                },
                            },
                            DatiBeniServizi: {
                                DettaglioLinee: temp,
                                DatiRiepilogo: [
                                    {
                                        AliquotaIVA: r.vat + '.00',
                                        Arrotondamento: '',
                                        ImponibileImporto: r.totalPrice,
                                        /* Imposta: '00.00',
                                        EsigibilitaIVA: '' */
                                    },

                                ],
                            }
                        },
                    ],
                };

                console.warn(fattura)


                const xmlString = WriteXml(fattura);

                const blob = new Blob([xmlString], { type: 'application/xml' });
                const url = URL.createObjectURL(blob);

                var data = {
                    xml: xmlString,
                }
                console.log(data)
                var resUpdate = await DataManager.updateItem('invoice', data, item.id);
                console.log(resUpdate)
                if (resUpdate.success === 1) {
                    toast.success("XML rigenerato con successo.", { theme: 'colored', position: 'bottom-center' })
                    refreshData()
                } else {
                    toast.error("Errore nel generare il file XML", { theme: 'colored', position: 'bottom-center' })
                }
            } else {
                toast.warning("Inserire un progressivo per poter procedere.", { theme: 'colored', position: 'bottom-center' })
            }


        }
    }





    const [showModal, setShowModal] = useState(null);
    const [progressivo, setProgressivo] = useState(null);
    const [descrizione, setDescrizione] = useState(null);
    const [aliquota, setAliquota] = useState(null);
    const [causale, setCausale] = useState(null);
    function closeModal() {
        setShowModal(false)
    }
    function openModal() {
        setShowModal(true)
    }

    async function generateXMLV2() {
        closeModal()
        console.log(item)
        var dateNow = moment().format('YYYY-MM-DD');


        const fattura = {
            FatturaElettronicaHeader: {
                DatiTrasmissione: {
                    IdTrasmittente: {
                        IdPaese: settings.dati_fattura.statoPIVA,
                        IdCodice: settings.dati_fattura.PIVA,
                    },
                    ProgressivoInvio: progressivo,
                    FormatoTrasmissione: settings.dati_fattura.formatoTrasmissione,
                    CodiceDestinatario: item.idCustomer.sdi,
                    PECDestinatario: item.idCustomer.pec
                },
                CedentePrestatore: {
                    DatiAnagrafici: {
                        IdFiscaleIVA: {
                            IdPaese: settings.dati_fattura.statoPIVA,
                            IdCodice: settings.dati_fattura.PIVA,
                        },
                        CodiceFiscale: settings.dati_fattura.PIVAcompleta,
                        Anagrafica: {
                            Denominazione: settings.dati_fattura.denominazione,
                        },
                        RegimeFiscale: settings.dati_fattura.regimeFiscale,
                    },
                    Sede: {
                        Indirizzo: settings.dati_fattura.indirizzo,
                        CAP: settings.dati_fattura.cap,
                        Comune: settings.dati_fattura.comune,
                        Provincia: settings.dati_fattura.provincia,
                        Nazione: 'IT'
                    },
                    IscrizioneREA: {
                        Ufficio: settings.dati_fattura.ufficio,
                        NumeroREA: settings.dati_fattura.numeroREA,
                        SocioUnico: settings.dati_fattura.socioUnico,
                        StatoLiquidazione: settings.dati_fattura.statoLiquidazione
                    },
                },
                CessionarioCommittente: {
                    DatiAnagrafici: {
                        IdFiscaleIVA: {
                            IdPaese: 'IT',
                            IdCodice: item.idCustomer.vatNumber
                        },
                        CodiceFiscale: item.idCustomer.vatNumber,
                        Anagrafica: {
                            Denominazione: item.idCustomer.name,
                        },
                    },
                    Sede: {
                        Indirizzo: item.idCustomer.route + ', ' + item.idCustomer.streetNumber,
                        CAP: item.idCustomer.postalCode,
                        Comune: item.idCustomer.locality,
                        Provincia: item.idCustomer.province,
                        Nazione: 'IT'
                    },
                },
            },
            FatturaElettronicaBody: [
                {
                    DatiGenerali: {
                        DatiGeneraliDocumento: {
                            TipoDocumento: 'TD01',
                            Divisa: 'EUR',
                            Data: dateNow,
                            Numero: progressivo,
                            ImportoTotaleDocumento: parseFloat(item.totalPayment).toFixed(2),
                            Causale: causale
                        },
                    },
                    DatiBeniServizi: {
                        DettaglioLinee: [{
                            NumeroLinea: 1,
                            Descrizione: descrizione,
                            Quantita: '1.0000',
                            PrezzoUnitario: parseFloat(item.totalPayment).toFixed(2),
                            PrezzoTotale: parseFloat(item.totalPayment).toFixed(2),
                            AliquotaIVA: aliquota + '.00',
                        }],
                        DatiRiepilogo: [
                            {
                                AliquotaIVA: aliquota + '.00',
                                ImponibileImporto: parseFloat(item.totalPayment).toFixed(2),
                                Imposta: parseFloat(parseFloat(item.totalPayment) * (aliquota / 100)).toFixed(2)
                            },

                        ],
                    }
                },
            ],
        };

        console.warn(fattura)

        const xmlString = WriteXml(fattura);

        const blob = new Blob([xmlString], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);


        const a = document.createElement('a');
        a.href = url;
        a.download = 'file.xml';

        document.body.appendChild(a);
        a.click();

        a.remove();

        var updateBody = {
            progressivo: progressivo,
            vat: aliquota,
            description: descrizione,
            status: { value: '5_GENERATE' }
        }
        var res = await DataManager.updateItem('customer_order_payment', updateBody, item.id)
        if (res.success === 1) {
            toast.success("XML generato con successo!", { theme: 'colored', position: 'bottom-center' })
            refreshData()
        } else {
            toast.error("Errore.", { theme: 'colored', position: 'bottom-center' })
        }

    }

    async function paidInvoice() {
        var updateBody = {
            status: { value: '5_GENERATE' }
        }
        var res = await DataManager.updateItem('customer_order_payment', updateBody, item.id)
        if (res.success === 1) {
            toast.success("Fattura pagata con successo!", { theme: 'colored', position: 'bottom-center' })
            refreshData()
        } else {
            toast.error("Errore.", { theme: 'colored', position: 'bottom-center' })
        }
    }



    const [statusModalCheckOffer, setStatusModalCheckOffer] = useState(false)
    function closeModalCheckOffer() {
        setStatusModalCheckOffer(false)
    }
    function openModalCheckOffer(id) {
        setStatusModalCheckOffer(true)
    }

    const [totConfirmOffer, setTotConfirmOffer] = useState(null)
    const [totRowsOffer, setTotRowsOffer] = useState(null)
    const [aboluteMargin, setAbsoluteMargin] = useState(null)
    const [margin, setMargin] = useState(null)
    async function checkPriceOffer() {
        openModalCheckOffer()
        var res = await DataManager.getItem('customer_offer', item.id);
        console.log(res)
        if (res.success === 1) {
            var co = res.body[0]
            var a = co.rows.reduce((a, c) => a + (parseFloat(c.listPrice) * parseFloat(c.quantity)), 0);
            const b = co.rows.reduce((sum, c) => {
                const price = parseFloat(c.listPrice) || 0;
                const qty = parseFloat(c.quantity) || 0;

                // Costruiamo il moltiplicatore partendo da 1
                let multiplier = 1;

                // Se commercial è diverso da "0" e non è vuoto, lo applichiamo
                if (
                    c.idSupplier.commercial_discount !== "0" &&
                    c.idSupplier.commercial_discount !== ""
                ) {
                    multiplier *= (parseFloat(c.idSupplier.commercial_discount) || 0) / 100;
                }

                console.log(multiplier)
                // Se cash_flow_discount è diverso da "0" e non è vuoto, lo applichiamo
                if (
                    c.idSupplier.cash_flow_discount !== "0" &&
                    c.idSupplier.cash_flow_discount !== ""
                ) {
                    multiplier *= (1 - (parseFloat(c.idSupplier.cash_flow_discount) || 0) / 100);
                }
                console.log(multiplier)

                console.log(sum, price, qty, multiplier)
                // Sommiamo il contributo di questa riga
                return sum + price * qty * multiplier;
            }, 0);

            const absoluteMargin = a - b;
            const markupPercentage = ((a - b) / a) * 100;

            console.log(b)
            setTotConfirmOffer(b)
            setTotRowsOffer(a)
            setAbsoluteMargin(absoluteMargin)
            setMargin(markupPercentage)

        }
        openModalCheckOffer()
    }



    const [statusModalDelete, setStatusModalDelete] = useState(false)
    function closeModalDelete() {
        setStatusModalDelete(false)
    }
    function openModalDelete() {
        setStatusModalDelete(true)
    }

    async function delivered() {
        console.log('ITEM', item)
        try {
            const deliveryRowsResponse = await DataManager.getItem('customer_order_delivery', item.id)
            if (deliveryRowsResponse.success !== 1 || !deliveryRowsResponse.body || deliveryRowsResponse.body.length === 0) {
                throw new Error(deliveryRowsResponse.message || 'Impossibile recuperare le righe della consegna.')
            }

            const deliveryRows = Array.isArray(deliveryRowsResponse.body[0].rows) ? deliveryRowsResponse.body[0].rows : []

            if (deliveryRows.length) {
                for (let i = 0; i < deliveryRows.length; i++) {
                    const deliveryRow = deliveryRows[i]
                    const deliveryRowId = deliveryRow && deliveryRow.id
                    if (deliveryRowId) {
                        const deliveryRowUpdate = await DataManager.updateItem('customer_order_delivery_row', { status: { value: "10_DELIVERED", label: "10_DELIVERED" } }, deliveryRowId)
                        if (deliveryRowUpdate.success !== 1) {
                            throw new Error(deliveryRowUpdate.message || 'Impossibile aggiornare la riga della consegna.')
                        }
                    }

                    let orderRowId = null
                    if (deliveryRow && deliveryRow.idCustomerOrderRow !== undefined && deliveryRow.idCustomerOrderRow !== null) {
                        if (typeof deliveryRow.idCustomerOrderRow === 'object') {
                            orderRowId = deliveryRow.idCustomerOrderRow.id
                        }
                        else {
                            orderRowId = deliveryRow.idCustomerOrderRow
                        }
                    }
                    if (orderRowId) {
                        const orderRowUpdate = await DataManager.updateItem('customer_order_row', { status: { value: "20_DELIVERED", label: "20_DELIVERED" } }, orderRowId)
                        if (orderRowUpdate.success !== 1) {
                            throw new Error(orderRowUpdate.message || 'Impossibile aggiornare la riga dell\'ordine cliente.')
                        }
                    }
                }
            }

            const deliveryStatus = { status: { value: "20_DELIVERED", label: "20_DELIVERED" } }
            const updateDelivery = await DataManager.updateItem(entity, deliveryStatus, item.id)
            if (updateDelivery.success !== 1) {
                toast.error(updateDelivery.message || 'Impossibile aggiornare la consegna.')
                return
            }

            const orderId = item?.idCustomerOrder?.id || item?.idCustomerOrder
            if (orderId) {
                const orderResponse = await DataManager.getItem('customer_order', orderId)
                if (orderResponse.success === 1 && orderResponse.body && orderResponse.body.length > 0) {
                    const customerOrder = orderResponse.body[0]
                    const orderRows = Array.isArray(customerOrder.rows) ? customerOrder.rows : []
                    const allDelivered = orderRows.length > 0 && orderRows.every(row => {
                        const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                        return statusValue === '20_DELIVERED'
                    })
                    const anyDelivered = orderRows.some(row => {
                        const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                        return statusValue === '20_DELIVERED'
                    })

                    let nextStatus = null
                    if (allDelivered) {
                        nextStatus = { value: '10_COMPLETED', label: '10_COMPLETED' }
                    }
                    else if (anyDelivered) {
                        nextStatus = { value: '15_PARTIAL_DELIVERED', label: '15_PARTIAL_DELIVERED' }
                    }

                    if (nextStatus !== null) {
                        const updateOrder = await DataManager.updateItem('customer_order', { status: nextStatus }, customerOrder.id)
                        if (updateOrder.success !== 1) {
                            throw new Error(updateOrder.message || 'Impossibile aggiornare lo stato dell\'ordine cliente.')
                        }
                    }
                }
            }

            toast.success("Consegnato con successo!", { theme: 'colored' })
            refreshData()
        }
        catch (error) {
            toast.error(error.message || 'Impossibile completare la consegna.')
        }

    }





    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample':
                            return (
                                <span>Test</span>
                            );
                        case 'customer':
                            return (
                                <>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="outline-secondary" size='sm'>
                                            Azioni
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => showCustomerOffer(item)} className='py-0'>Preventivi</Dropdown.Item>
                                            <Dropdown.Item onClick={() => newCustomerOffer(item)} className='py-0'>Crea preventivo</Dropdown.Item>
                                            <hr className='my-2' />
                                            <Dropdown.Item onClick={() => showCustomerOrder(item)} className='py-0'>Ordini</Dropdown.Item>
                                            <Dropdown.Item onClick={() => newCustomerOrder(item)} className='py-0'>Crea ordine</Dropdown.Item>
                                            <hr className='my-2' />
                                            <Dropdown.Item onClick={() => showModalPayment(item)} className='py-0'>Storico pagamenti</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>


                                    {statusCustomerModal && customerHistoryEntity ? <ModalList entity={customerHistoryEntity} searchObj={customerHistorySearchObj} status={statusCustomerModal} closeModal={closeCustomerModal} /> : <></>}
                                    {statusPaymentModal && paymentEntity ? <ModalList entity={paymentEntity} searchObj={paymentSearchObj} status={statusPaymentModal} closeModal={closeModalPayment} /> : <></>}

                                </>
                            );
                        case 'gyv_customer_offer':
                            return (
                                <>
                                    {(parseInt(userInfo.level) === 0 || parseInt(userInfo.level) === 1) ? <>
                                        <Button className='m-1' variant='outline-secondary' size='sm' onClick={() => checkPriceOffer()}>Calcolo margine</Button>
                                    </> : null}

                                    {item.status.value === '0_PENDING' || item.status.value === '5_PRESALE' ?
                                        <Button className='m-1' variant='outline-success' size='sm' onClick={() => customerOfferConvertInOrder()}>Converti</Button>
                                        : <></>}

                                    {item.status.value === '0_PENDING' ? <>
                                        <Button className='m-1' variant='outline-danger' size='sm' onClick={() => openModalDelete()}>Rifiuta</Button>
                                    </> : null}
                                    {item.status.value === '10_CONFIRMED' ? <>
                                        <Button className='m-1' variant='outline-danger' size='sm' onClick={() => revert()}>Annulla</Button>
                                    </> : null}
                                    <Button className='m-1' variant='outline-primary' size='sm' onClick={() => openModalEntityViewerCustomerOffer()}>Dettagli</Button>
                                    <Button onClick={() => previewCustomerOffer(item)} size="sm" variant="outline-secondary" className='m-1'><FontAwesomeIcon className='ms-1 me-1' icon='print'></FontAwesomeIcon></Button>

                                    {statusModalEntityViewerCustomerOffer !== false && (
                                        <ModalEntityViewer entity={'customer_offer'} item={item} status={statusModalEntityViewerCustomerOffer} closeModal={closeModalEntityViewerCustomerOffer} />
                                    )}



                                    <Modal show={statusModalCheckOffer} onHide={closeModalCheckOffer} size='lg'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Margine</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Prezzo di listino articoli</p>
                                                    <h3>{parseFloat(totRowsOffer).toLocaleString('it-IT', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} €</h3>
                                                </Col>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Costo stimato articoli</p>
                                                    <h3>{parseFloat(totConfirmOffer).toLocaleString('it-IT', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} €</h3>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Margine assoluto</p>
                                                    <h3>{parseFloat(aboluteMargin).toLocaleString('it-IT', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })} €</h3>
                                                </Col>
                                                <Col className='text-center'>
                                                    <p className='mb-0'>Margine percentuale</p>
                                                    <h3>{parseInt(margin)} %</h3>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                    </Modal>



                                    <Modal show={statusModalDelete} onHide={closeModalDelete}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Rifiuta preventivo</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col className='text-center'>
                                                    <p>Sei sicuro di voler rifiutare il preventivo?</p>
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant='secondary' onClick={() => closeModalDelete()}>No, indietro</Button>
                                            <Button variant='danger' onClick={() => declined()}>Si, rifiuta</Button>
                                        </Modal.Footer>
                                    </Modal>




                                </>
                            );
                        case 'gyv_customer_order':
                            return (
                                <>
                                    <DGLTH_customer_order item={item} props={props} entity={entity} refreshData={refreshData}></DGLTH_customer_order>
                                </>
                            );
                        case 'gyv_supplier_order':
                            return (
                                <>
                                    <DGLTH_supplier_order item={item} props={props} entity={entity} refreshData={refreshData}></DGLTH_supplier_order>
                                </>
                            );
                        case 'gyv_customer_order_delivery':
                            return (
                                <>
                                    {item.status.value === "10_CREATED" ? (
                                        <Button size="sm" variant='outline-primary' onClick={() => delivered()}>Consegnato</Button>
                                    ) : null}
                                    {item.status.value !== "0_PENDING" ? (
                                        <Button size='sm' variant='outline-secondary' onClick={() => ddtCustomerOrder(item)} className='ms-1'><FontAwesomeIcon icon={'print'}></FontAwesomeIcon></Button>
                                    ) : null}
                                </>
                            );
                        case 'invoice':
                            return (
                                <>
                                    <Button size="sm" onClick={() => downloadXml()}>Download XML</Button>
                                    <Button size="sm" className='ms-1' variant='outline-secondary' onClick={() => generateXml(item)}>Rigenera XML</Button>
                                    {/* <Button size="sm" className='ms-1' variant='outline-secondary' onClick={() => printInvoice(item)}>Stampa fattura</Button> */}
                                </>
                            );
                            {/*  case 'customer_order_payment':
                            return (
                                <>
                                    <Button size="sm" variant='outline-primary' onClick={() => openModal()}>Genera XML</Button>
                                    {item.status && item.status.value !== "10_PAID" ? <>
                                        <Button size="sm" className='mx-1' variant='outline-success' onClick={() => paidInvoice()}>Pagata</Button>
                                    </> : null}



                                    <Modal show={showModal} onHide={closeModal} size='lg'>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Progressivo</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Inserisci progressivo</Form.Label>
                                                        <Form.Control type="number" onChange={(e) => setProgressivo(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Inserisci aliquota</Form.Label>
                                                        <Form.Control type="number" onChange={(e) => setAliquota(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                                        <Form.Label>Inserisci causale</Form.Label>
                                                        <Form.Control type="text" onChange={(e) => setCausale(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label className='mb-2'>Inserisci descrizione</label>
                                                    <Editor
                                                        apiKey={settings.tinyKey}
                                                        onEditorChange={(value) => setDescrizione(value)}
                                                        init={{
                                                            height: 500,
                                                            menubar: true,
                                                            plugins: [
                                                                'lists', 'link', 'image', 'preview',
                                                                'visualblocks', 'code', 'fullscreen',
                                                                'media', 'table', 'advlist', 'code', 'wordcount'
                                                            ],
                                                            toolbar: 'undo redo | formatselect | ' +
                                                                'bold italic backcolor | alignleft aligncenter ' +
                                                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                                                'removeformat | fullscreen',
                                                            content_style: 'body { font-family:Helvetica,Arial,sans-serif;font-size:14px; }'
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="secondary" onClick={closeModal}>
                                                Indietro
                                            </Button>
                                            <Button variant="primary" onClick={() => generateXMLV2()}>
                                                Genera
                                            </Button>
                                        </Modal.Footer>
                                    </Modal>
                                </> 
                            );*/}
                        default:
                            return (
                                <></>
                            );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
